import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useBoards } from "../../../../reactQuery/boards";
import { getBoardRows } from "../utils/boardManagementUtils";
import { getResponseData } from "../../../../reactQuery/response";

export function useBoardManagementTable() {
  const { isLoading, boards, isError, error, refetch } = useBoards();
  const [filterBoard] = useCustomSearchParams("boards-type");
  const searchText = useSelector((state) => state.search.searchText);

  const boardData = useMemo(
    () => getResponseData(boards, []),
    [boards]
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  const rows = useMemo(() => {
    return getBoardRows(boardData, searchText, filterBoard);
  }, [boardData, filterBoard, searchText]);

  return {
    rows,
    isLoading,
    isError,
    error,
  };
}
